<template>
  <!-- img 模式需要提取 URL -->
  <img v-if="mode === 'img'" :src="imageUrl" v-bind="$attrs" />

  <!-- background 模式直接使用 CSS 变量 -->
  <div v-else class="theme-image" :style="imageStyle" v-bind="$attrs">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useTheme } from "@/composables/useTheme";
import { getThemeImageUrl, getThemeImageVar } from "@/theme/theme-utils";

const props = withDefaults(
  defineProps<{
    path?: string;
    name: string;
    mode?: "img" | "background";
  }>(),
  { mode: "background" }
);

const route = useRoute();
const { currentTheme } = useTheme();

// 用于拼 CSS 变量名 / 图片映射 key
const pathName = computed(() => props.path || (route.name as string) || "index");

/**
 * background 模式：使用 CSS 变量（零 JS 开销）
 */
const imageStyle = computed(() => ({
  backgroundImage: getThemeImageVar(pathName.value, props.name),
}));

/**
 * img 模式：从 JS 映射获取 URL（纯响应式计算，无 DOM 操作）
 * 自动响应 currentTheme / props.name / pathName 变化
 */
const imageUrl = computed(() => {
  // 访问 currentTheme.value 以建立响应式依赖
  void currentTheme.value;
  return getThemeImageUrl(pathName.value, props.name);
});
</script>

<style scoped>
.theme-image {
  box-sizing: border-box;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>
